import React, { PropTypes, Component } from 'react';
import './SearchPageSetting.less';
import { CheckSwitchButton } from '../../../../index';
import { TopNavPage } from 'mutants-mobile-navigator';
import QueryApi from '../api/QueryApi';
import CacheRoute, { dropByCacheKey, getCachingKeys } from 'react-router-cache-route';
import _cloneDeep from 'lodash/cloneDeep';

@TopNavPage
export default class SearchPageSetting extends Component {

  navTitle() {
    return '高级查询设置';
  }

  navBack() {
    return true;
  }

  navLeftClick() {
    this.pop();
  }

  navRightContent() {
    return (
      <div className='navRight'>
        <div onClick={this.save}>保存</div>
      </div>
    )
  }

  constructor(props) {
    super(props);
    this.state = {
      // ...props.location.state,
      planInfo: _cloneDeep(props.location.state.planInfo),
      hiddenItems: props.location.state.hiddenItems,
      isChanged: []
    }
  }

  save = async (e) => {
    if (this.state.isChanged.length > 0) {
      let save = await QueryApi.updateMBVouSearchItems(this.state.planInfo.id, this.state.planInfo.items.map(item => ({
        code: item.code,
        visible: item.visible,
        mode: item.mode,
        match: item.match,
        disabled: item.disabled,
        isSimpleSearchItem: item.isSimpleSearchItem
      })));
      console.log('保存查询项显示隐藏的接口 => ', save);
      if (save.code == 0) { // 保存成功
        dropByCacheKey('queryScheme')
        setTimeout(() => {
          if (true) {
            this.pop();
          }
        }, 100)
      } else {
        this.pop();
      }
    } else {
      this.pop();
    }
  }

  handleChange = (code, visible) => {
    let isChanged = [...this.state.isChanged];
    if (isChanged.indexOf(code) < 0) {
      isChanged.push(code);
    } else (
      isChanged.splice(isChanged.indexOf(code, 1))
    )
    let planInfo = this.state.planInfo;
    planInfo.items.find(item => item.code == code).visible = visible.value;
    this.setState({
      planInfo,
      isChanged
    }, () => {
      console.log(this.state.planInfo)
    })
  }
  render() {
    let { items } = this.state.planInfo;
    let { hiddenItems } = this.state;
    return (
      <div className='mobileSearchSetting'>
        {
          items.map(item => {
            // 有需要隐藏的项目 就隐藏
            if (hiddenItems && hiddenItems.length && hiddenItems.length > 0 && hiddenItems.indexOf(item.code) != -1) {
              return null;
            }
            return (
              <div className='item' key={item.id}>
                <label>{item.name}</label><CheckSwitchButton onChange={v => this.handleChange(item.code, v)} value={item.visible} />
              </div>
            )
          })
        }
      </div>
    )
  }
}
